/* tslint:disable */

export enum ComponentType {
  ActivityDefinition = 0,
  ConditionDefinition = 1,
  FindingDefinition = 2,
  ObservationDefinition = 3,
}
